interface Config {
  env: string
  analyticsId: string
  orderApiHost: string
  toolingApiHost: string
  feedbackFormUrl: string
}

export class ConfigService {
  private config: Config = (window as any).env

  getConfig() {
    return this.config
  }
}

const configService = new ConfigService()

export default configService
